module.exports = __webpack_public_path__ + "img/effect-1.6c292f22.png";